import * as A from './actions';
import { initialState } from './adapters';

export const reducer = {
  payCategories(state = initialState(), action) {
    switch (action.type) {
      case A.getPayCategoriesAction.type:
        return state;

      case A.getPayCategoriesAction.success: {
        return state.setIn(['list'], action.payload.list);
      }

      default:
        return state;
    }
  },
};
